<div class="job-categories-panel">
    <h3>Categories mapped to area</h3>
    @if (!selectedJob) {
        <div class="no-job-selected">Select a job before mapping categories</div>
    } @else if (selectedJob && isLoading() && !jobCategories()?.length) {
        <div>
            <div>Loading categories <app-bx-spinner color="grey" [diameter]="20" [strokeWidth]="2"></app-bx-spinner></div>
        </div>
    } @else if (selectedJob && !isLoading() && !jobCategories()?.length) {
        <div class="no-categories-selected">
            No categories have been created for this job. Create a category in Actual Costings to allocate an area
        </div>
    } @else if (selectedJob && jobCategories()?.length) {
        <div class="job-categories-job-details">
            <b>{{ selectedJob?.number + ' - ' + selectedJob?.description }}</b>
        </div>
        <div class="job-categories-list-container" [class.standalone-modal]="isModal">
            @for (item of jobCategories(); track $index) {
                <div class="job-categories-list-item" id="itemRow{{ item.iD_JobItem }}">
                    <div>{{ item.description }}</div>
                    <div class="job-category-container">
                        <ng-select
                            id="job-category-set-area-{{ $index }}"
                            [(ngModel)]="item.timesheetCategoryId"
                            [ngModelOptions]="{ standalone: true }"
                            [items]="item.timesheetCategoryId ? providerCategories() : availableCategories()"
                            class="light select-category"
                            (change)="setAreaId(item, $event)"
                            bindLabel="name"
                            bindValue="id"
                            [disabled]="!!item.timesheetCategoryId || isLoading()">
                            <ng-template ng-label-tmp let-item="item"> {{ item.name }} </ng-template>
                            <ng-template ng-option-tmp let-item="item"> {{ item.name }} </ng-template>
                        </ng-select>
                        @if (!item.timesheetCategoryId?.length) {
                            <button
                                id="job-category-create-area-{{ $index }}"
                                type="button"
                                class="btn btn-bx-primary min-width-100"
                                [disabled]="isLoading()"
                                (click)="createArea(item)">
                                Create area
                            </button>
                        } @else {
                            <button
                                id="job-category-unlink-area-{{ $index }}"
                                type="button"
                                class="btn btn-bx-secondary-stroked min-width-100"
                                [disabled]="isLoading()"
                                (click)="unlinkArea(item)">
                                Unlink
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
@if (isModal) {
    <div class="job-categories-footer">
        <button id="close-job-categories-timesheet-area-modal-close" type="button" class="btn btn-primary-bxt" (click)="closeModal()">
            Close
        </button>
    </div>
}
